<template>
  <div style="height: 100%; background-color: #f2f4f7; min-height: 100vh">
    <div class="newInvitation" v-if="showInvitationInfo || !$route.query.shareId">
      <div class="navBar-wrap">
        <NavBar :narBarTitle="title" :onSubmit="onConfirm" :okButton="true" />
      </div>
      <!-- <van-pull-refresh v-model="isLoading" @refresh="onRefresh"> -->
      <!-- <div v-if="sourceIsH5" style="height: 45px" /> -->
      <div class="content">
        <Card :title="$t('接待人信息')">
          <template v-slot>
            <div class="receptionistInfo">
              <div class="form-item" :class="{ 'color-change': mobileIntervieweeError }" v-if="user.companyId == 303">
                <van-field v-model="intervieweeMobile" type="tel" :placeholder="$t('请输入您的手机号，用于接收访客到达信息')"
                  :error-message="mobileIntervieweeError" @blur="intervieweedateMobile"
                  :disabled="$route.query.shareId && user.companyId != 303" />
              </div>
              <div class="form-item select" @click="onPersonnel" v-else>
                <p class="form-label">{{ intervieweeName }}</p>
                <div class="form-icon" v-if="!shareId">
                  <img :src="formIcon" alt="" />
                </div>
              </div>
              <div class="form-item select" @click="onAddress">
                <p class="form-label-address">{{ currentAddress }}</p>
                <div class="form-icon" v-if="!shareId">
                  <img :src="formIcon" alt="" />
                </div>
              </div>
            </div>
          </template>
        </Card>
        <DateRangePicker @update-time="handleUpdateTime" :isClickable="true" :startTime="startTime"
          :endTime="endTime" />
        <div class="time-notice" v-if="shareId">
          <img src="@/assets/images/notice.png" alt="" />
          <span>{{ $t('访客需在此时间段内签到，过期则失效') }}</span>
        </div>
        <Card :title="$t('访客信息')">
          <div class="form-item" :class="{ 'color-change': nameError }">
            <div class="asterisk">*</div>
            <van-field v-model="visitorName" :placeholder="$t('请输入访客姓名')" :error-message="nameError"
              @blur="validateName" />
          </div>
          <div class="form-item" :class="{ 'color-change': mobileError }">
            <div class="asterisk">*</div>
            <van-field v-model="visitorMobile" type="tel" :placeholder="$t('请输入访客电话号码')" :error-message="mobileError"
              @blur="validateMobile" />
          </div>
          <div class="form-item select" @click="onPurpose">
            <div style="display: flex">
              <div class="asteriskradio">*</div>
              <p class="form-label">
                <span class="form-label-purpose">{{ $t('到访目的：') }}</span>{{ radio }}
              </p>
            </div>
            <div class="form-icon">
              <img :src="formIcon" alt="" />
            </div>
          </div>
          <div v-if="!moreSettings" class="form-item select" @click="showMoreSettings">
            <p class="form-label-purpose">{{ $t('更多设置项') }}</p>
            <div class="form-icon">
              <img :src="formIcon" alt="" />
            </div>
          </div>
          <div v-if="moreSettings">
            <div class="form-item">
              <van-field v-model="visitorCompany" :placeholder="$t('请输入访客公司')" style="width: 100%" />
            </div>
            <div class="form-item select">
              <p class="form-label">{{ $t('到访人数') }}</p>
              <van-field v-model="visitorNumber" class="form-number">
                <template #input>
                  <van-stepper v-model="visitorNumber" />
                </template>
              </van-field>
            </div>
            <div class="form-item select" style="height: 86px">
              <div>
                <p class="form-label">{{ $t('上传人像信息') }}</p>
                <p class="form-tips" @click="toFaceTips">
                  <span>*</span>{{ $t('注意事项') }}
                </p>
              </div>
              <input type="file" name="img" @change="imgChange" ref="fileInput" style="display: none"
                accept="image/*" />
              <div class="cropper">
                <img :src="photo" class="img" @click="triggerFileInput" />

                <!-- option是配置，格式是对象，getbase64Data是组件的一个方法获取裁剪完的头像 2.14新增一个获取getblobData的方法 -->
                <h5-cropper hide-input ref="cropper" :option="option" @getFile="getFile"
                  @getbase64Data="getbase64Data"></h5-cropper>
              </div>
              <!-- <div class="form-avatar">
                <img :src="uploadAvatar" alt="" class="form-avatar" />
              </div> -->
            </div>
          </div>
        </Card>
        <Card :title="$t('接待方式')">
          <div class="form-item select" @click="onSignIn">
            <p class="form-label">{{ $t(signInType) }}</p>
            <div class="form-icon" v-if="!shareId">
              <img :src="formIcon" alt="" />
            </div>
          </div>
          <div class="form-item select" @click="onPT" v-if="showRobot">
            <div style="display: flex">
              <div class="asteriskradio">*</div>
              <p class="form-label">
                <span class="form-label-purpose">{{ $t('选择目的地：') }}</span>{{ currentPT }}
              </p>
            </div>
            <div class="form-icon" v-if="!shareId">
              <img :src="formIcon" alt="" />
            </div>
          </div>
          <div class="form-item select" @click="onGuidePopup" v-if="showGuide">
            <div style="display: flex">
              <div class="asteriskradio">*</div>
              <p class="form-label">
                <span class="form-label-purpose">{{
                  $t('选择讲解路线：')
                  }}</span>{{ currentGuide }}
              </p>
            </div>
            <div class="form-icon" v-if="!shareId">
              <img :src="formIcon" alt="" />
            </div>
          </div>
          <div class="form-item select" v-if="!shareId">
            <p class="form-label-purpose">{{ $t('预约同时段会议室') }}</p>
            <van-switch :value="IsSubscribe" @input="SubscribeChange" size="22" :disabled="isCrossDayVisit" />
          </div>
          <div v-if="isCrossDayVisit" class="cross-day-tip">
            <span style="color: #999; font-size: 14px;">跨天预约不支持会议室预约</span>
          </div>
          <div v-if="IsSubscribe">
            <div class="form-item select" @click="onConference">
              <p class="form-label">
                <span class="form-label-purpose">{{ $t('预约会议室：') }}</span>{{
                  ConferenceColumns.length == 0 ? $t('暂无会议室') : Conference
                }}
              </p>
              <div class="form-icon">
                <img :src="formIcon" alt="" />
              </div>
            </div>
            <div class="form-item select" style="justify-content: flex-start">
              <p class="form-label-purpose">{{ $t('预约时间段：') }}</p>
              <div class="time-period">
                <div class="time-value">
                  {{
                    setTime(visitStartTime, 10) + '-' + setTime(visitEndTime, 2)
                  }}
                </div>
                <div :class="{
                  'time-type': IsSubscribeTitle == $t('可预约'),
                  'time-type-no': IsSubscribeTitle == $t('不可预约'),
                }" v-if="!statusLoading">
                  {{ IsSubscribeTitle }}
                </div>
              </div>
            </div>
          </div>
        </Card>
        <Card :title="$t('更多')" v-if="!shareId && !$route.query.visitorId">
          <div class="form-item select" @click="toSendInvitation">
            <p class="form-label-purpose">{{ $t('访客自填邀约信息') }}</p>
            <div class="form-icon">
              <img :src="formIcon" alt="" />
            </div>
          </div>
          <div class="form-item select" @click="toVisitors">
            <p class="form-label-purpose">{{ $t('邀约历史') }}</p>
            <div class="form-icon">
              <img :src="formIcon" alt="" />
            </div>
          </div>
        </Card>
      </div>
      <!-- </van-pull-refresh> -->
      <van-popup v-model="showPT" position="bottom" safe-area-inset-bottom round overlay-class="overlay">
        <div class="select-box">
          <div class="close" @click="showPT = false">{{ $t('取消') }}</div>
          <p class="title">{{ $t('选择目的地') }}</p>
          <div class="submit" @click="selectPT">{{ $t('确定') }}</div>
        </div>
        <div>
          <van-radio-group v-model="currentPT" class="timeList" style="
              background-color: #f2f4f7;
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: 12px;
            ">
            <van-radio :name="item.name" class="purposeListCard" icon-size="18px" v-for="(item, idx) in PTList"
              :key="item.name">
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? radiobtnCheck : radiobtnDefault" />
              </template>
              <div class="timeListRange" :ref="'range' + idx">
                {{ item.name }}
              </div>
            </van-radio>
          </van-radio-group>
        </div>
      </van-popup>
      <van-popup v-model="showGuidePopup" position="bottom" safe-area-inset-bottom round overlay-class="overlay">
        <div class="select-box">
          <div class="close" @click="showGuidePopup = false">
            {{ $t('取消') }}
          </div>
          <p class="title">{{ $t('选择讲解路线') }}</p>
          <div class="submit" @click="selectGuide">{{ $t('确定') }}</div>
        </div>
        <div>
          <van-radio-group v-model="currentGuide" class="timeList" style="
              background-color: #f2f4f7;
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: 12px;
            ">
            <van-radio :name="item.name" class="purposeListCard" icon-size="18px" v-for="(item, idx) in guideList"
              :key="item.name">
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? radiobtnCheck : radiobtnDefault" />
              </template>
              <div class="timeListRange" :ref="'range' + idx">
                {{ item.name }}
              </div>
            </van-radio>
          </van-radio-group>
        </div>
      </van-popup>
      <van-popup v-model="showPersonnel" position="bottom" safe-area-inset-bottom round overlay-class="overlay">
        <div class="select-box">
          <div class="close" @click="showPersonnel = false">
            {{ $t('取消') }}
          </div>
          <p class="title">{{ $t('选择接待人') }}</p>
          <div class="submit" @click="addInterviewee">{{ $t('确定') }}</div>
        </div>
        <div>
          <van-radio-group v-model="personnelResult" class="timeList">
            <div class="searchBox">
              <div class="searchContent">
                <div class="icon-wrapper">
                  <img src="@/assets/images/newSearch.svg" alt="" />
                </div>
                <van-field v-model="searchMsg" :placeholder="$t('搜索人员')" class="search" @input="selectInterviewee">
                </van-field>
              </div>
            </div>
            <van-radio :name="item" class="intervieweeListCard" icon-size="18px" v-for="(item, idx) in searchList"
              :key="item.id">
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? radiobtnCheck : radiobtnDefault" />
              </template>
              <div class="timeListRange" :ref="'range' + idx">
                {{ item.name }}
                <span v-show="item.departmentName" style="color: #707a8a">({{ item.departmentName }})</span>
              </div>
            </van-radio>
          </van-radio-group>
        </div>
      </van-popup>
      <van-popup v-model="showAddress" position="bottom" safe-area-inset-bottom round overlay-class="overlay">
        <div class="select-box">
          <div class="close" @click="showAddress = false">{{ $t('取消') }}</div>
          <p class="title">{{ $t('选择接待地址') }}</p>
          <div class="submit" @click="confirmSelection">{{ $t('确定') }}</div>
        </div>
        <div>
          <van-radio-group v-model="currentAdderssResult" class="timeList">
            <van-radio :name="item.id" class="timeListCard" icon-size="18px" v-for="(item, idx) in addressList"
              :key="item.id">
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? radiobtnCheck : radiobtnDefault" />
              </template>
              <div class="timeListRange" :ref="'range' + idx">
                {{ item.address }}
              </div>
            </van-radio>
          </van-radio-group>
        </div>
      </van-popup>
      <van-popup v-model="showPurpose" position="bottom" safe-area-inset-bottom round overlay-class="overlay">
        <div class="select-box">
          <div class="close" @click="showPurpose = false">{{ $t('取消') }}</div>
          <p class="title">{{ $t('到访目的') }}</p>
          <div class="submit" @click="purposeSelection">{{ $t('确定') }}</div>
        </div>
        <div>
          <van-radio-group v-model="purposeResult" class="timeList" style="
              background-color: #f2f4f7;
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: 12px;
            ">
            <van-radio :name="item.value" class="purposeListCard" icon-size="18px" v-for="(item, idx) in purposeList"
              :key="item.value">
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? radiobtnCheck : radiobtnDefault" />
              </template>
              <div class="timeListRange" :ref="'range' + idx" style="font-weight: 500">
                {{ item.value }}
              </div>
            </van-radio>
          </van-radio-group>
        </div>
      </van-popup>
      <van-popup v-model="showSignIn" position="bottom" safe-area-inset-bottom round overlay-class="overlay">
        <div class="select-box">
          <div class="close" @click="showSignIn = false">{{ $t('取消') }}</div>
          <p class="title">{{ $t('选择接待方式') }}</p>
          <div class="submit" @click="signInSelection">{{ $t('确定') }}</div>
        </div>
        <div>
          <van-radio-group v-model="currentSignInResult" class="timeList" style="
              background-color: #f2f4f7;
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: 12px;
            ">
            <van-radio :name="item.name" class="purposeListCard" style="height: 88px" icon-size="18px"
              v-for="(item, idx) in signInTypeList" :key="idx + 2500">
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? radiobtnCheck : radiobtnDefault" />
              </template>
              <div class="purposeBox">
                <div class="timeListRange" :ref="'range' + idx">
                  {{ $t(item.name) }}
                </div>
                <img :src="getValueByText(item.name)" alt="" />
              </div>
            </van-radio>
          </van-radio-group>
        </div>
      </van-popup>
      <van-popup v-model="showHyvisible" position="bottom" safe-area-inset-bottom round overlay-class="overlay">
        <div class="select-box">
          <div class="close" @click="showHyvisible = false">
            {{ $t('取消') }}
          </div>
          <p class="title">{{ $t('选择预约会议室') }}</p>
          <div class="submit" @click="conferenceSelection">
            {{ $t('确定') }}
          </div>
        </div>
        <div>
          <van-radio-group v-model="currentConferenceResult" class="timeList">
            <van-radio :name="item.id" class="timeListCard" icon-size="18px" v-for="(item, idx) in ConferenceColumns"
              :key="idx + 2500">
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? radiobtnCheck : radiobtnDefault" />
              </template>
              <div class="timeListRange" :ref="'range' + idx">
                {{ item.name }}
              </div>
            </van-radio>
          </van-radio-group>
        </div>
      </van-popup>
    </div>
    <div class="newInvitation" v-else>
      <div class="navBar-wrap">
        <NavBar :narBarTitle="title" />
      </div>
      <div class="refusalInfo">
        <van-button round block type="info" native-type="submit" class="blue-btn" @click="toShowToast()">{{
          $t('查看用户协议与隐私设置')
        }}</van-button>
      </div>
    </div>
    <van-dialog v-model="showToast" show-cancel-button confirmButtonColor="#009BFF" cancelButtonColor="#009BFF"
      @confirm="IsDoOk()" class="outsiderStyle" :cancelButtonText="$t('拒绝')" :confirmButtonText="$t('我已阅读并同意')">
      <template #title>
        <div class="outsider-info">
          <h2 class="outsider-title">NewWork用户协议与隐私政策</h2>

          <div><strong>生效日期：2025年10月22日</strong></div>

          <h3>引言</h3>

          <p>
            欢迎您通过本链接访问我们的产品NewWork（包括App等产品提供的服务，以下简称"产品和服务"）。NewWork是由上海新柏石智能科技股份有限公司开发并运营的。您在此提供的信息是由武田制药委托上海新柏石智能科技股份有限公司（以下简称"我们"）收集并管理，用于访客登记与出入管理。确保用户的数据安全和隐私保护是我们的首要任务，本用户协议与隐私政策载明了您访问和使用我们的产品和服务时所收集的数据及其处理方式。
          </p>

          <p>
            请您在继续使用我们的产品前务必认真仔细阅读并确认充分理解本用户协议与隐私政策全部规则和要点，一旦您选择同意，即视为您同意本用户协议与隐私政策的全部内容，同意我们按其收集和使用您的相关信息。如您在在阅读过程中，对本政策有任何疑问，可联系我们的客服咨询，请通过
            zhou.he@newbest.com.cn 或产品中的反馈方式与我们取得联系。如您不同意相关协议或其中的任何条款的，您应停止使用我们的产品和服务。</p>

          <p>关于上海新柏石智能科技股份有限公司如何处理个人数据的详细信息，请参阅<a href="https://www.newbest.com.cn/"
              target="_blank">https://www.newbest.com.cn/</a>。关于武田制药如何处理个人数据，更多详细信息请登录<a href="https://www.Takeda.com"
              target="_blank">www.Takeda.com</a>。</p>

          <h3>我们将收集哪些个人信息</h3>

          <p>我们提供服务时，可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。我们收集的信息包括：姓名、联系方式（如手机号码、邮箱等）。</p>

          <h3>我们处理个人信息的目的</h3>

          <p>我们将处理您的个人信息用于访客登记与出入管理。</p>

          <h3>数据存储与保留期限</h3>

          <p>您提供的信息将在我们履行完毕本服务后的合理时间内保留，之后将被安全删除，法律要求或允许保留更长时间的除外。</p>

          <h3>数据主体权利</h3>

          <p>您有权要求访问您的个人数据，更正您个人数据中的任何错误，或者如果您的个人数据存在缺失或不完整之处，补充完整您的个人数据。您还有权要求删除本产品服务所收集和使用的您的个人数据，或限制这些数据的使用。</p>

          <h3>联系方式</h3>

          <p>如对本隐私政策或个人信息处理有任何疑问，可通过以下方式联系我们：</p>

          <p>上海新柏石智能科技股份有限公司的联系方式为：zhou.he@newbest.com.cn 或相关产品中所示的反馈方式与我们取得联系。</p>

          <p>武田制药的联系方式为：privacyoffice@takeda.com。</p>

          <h3>NewWork User Agreement and Privacy Policy</h3>

          <div><strong>Effective date: October 22, 2025</strong></div>

          <h3>Introduction</h3>

          <p>Welcome to NewWork (including the services provided by the App and other products, hereinafter referred to
            as "Products and Services"). NewWork is developed and operated by Shanghai Xinbaishi Intelligent Technology
            Co., Ltd. The information you provide here is collected and managed by Shanghai Xinbaishi Intelligent
            Technology Co., Ltd. (hereinafter referred to as "we", "us" or "our") under the entrustment of Takeda for
            visitor registration and access management. Ensuring the security and privacy of our users' data is our top
            priority. This User Agreement and Privacy Policy outlines the data we collect and how it is processed when
            you access and use our Products and Services.</p>

          <p>Please read this User Agreement and Privacy Policy carefully and ensure you fully understand all its rules
            and key points before continuing to use our products. By selecting "Agree", you are deemed to have accepted
            all content of this User Agreement and Privacy Policy and consented to our collection and use of your
            relevant information accordingly.</p>

          <p>If you have any questions about this policy while reading it, please contact our customer service for
            consultation via zhou.he@newbest.com.cn or through the feedback channels provided within the product. If you
            do not agree with this agreement or any of its terms, you should discontinue using our Products and
            Services.</p>

          <p>For more details on how Shanghai Xinbaishi Intelligent Technology Co., Ltd. processes personal information,
            please visit <a href="https://www.newbest.com.cn/" target="_blank">https://www.newbest.com.cn/</a>. For more
            information on how Takeda processes personal information, please visit <a href="https://www.Takeda.com"
              target="_blank">www.Takeda.com</a>.</p>

          <h3>What personal information we collect</h3>

          <p>To provide our services, we may collect, store, and use the following personal information related to you.
            If you choose not to provide this information, you may be unable to use certain services we offer, or the
            services may not function as intended. The types of information we collect include your name and contact
            details (such as mobile phone number and email address).</p>

          <h3>Purposes for which we process personal information</h3>

          <p>We will process your personal information for visitor registration and access management.</p>

          <h3>Data storage and retention period</h3>

          <p>The information you provide will be retained for a reasonable period after we have fulfilled the purposes
            of the services, after which it will be securely deleted, unless the law requires or permits a longer
            retention period.</p>

          <h3>Data subject rights</h3>

          <p>You have the right to request access to your personal data, to correct any inaccuracies in your personal
            information, or to supplement it if it is incomplete. You also have the right to request the deletion of
            your personal data collected and used through these Products and Services, or to restrict the processing of
            such data.</p>

          <h3>Contact information</h3>

          <p>If you have any questions regarding this Privacy Policy or the processing of your personal information, you
            may contact us using the following methods:</p>

          <p>Shanghai Xinbaishi Intelligent Technology Co., Ltd.: zhou.he@newbest.com.cn or via the feedback mechanisms
            available within the relevant products.</p>

          <p>Takeda: privacyoffice@takeda.com.</p>
        </div>
      </template>
    </van-dialog>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import H5Cropper from 'vue-cropper-h5'
import { isMobileType } from '@/utils/isMobileType.js'
Vue.use(H5Cropper)
import {
  visitorSave,
  getDictionary,
  getUserList,
  getRobotWork,
  getVisitaddress,
  getVisit,
  visitorUpdate,
  getMeetingRoomByArea,
  queryAppointmentList,
  bookAppointment,
  getMeetingRoomConfig,
  uploadFace,
} from '@/services/api'
import NavBar from '@/components/newNavBar'
import Card from '@/components/newCard'
import DateRangePicker from '@/components/DateRangePicker'
import formIcon from '@/assets/images/form-icon.svg'
import uploadAvatar from '@/assets/images/upload-avatar.png'
// import radiobtnDefault from '@/assets/images/Radiobtn_default.png'
// import radiobtnCheck from '@/assets/images/Radiobtn_check.png'
import Vue from 'vue'
import { ref } from 'vue'
import { I18nTemplateForSubmit, I18nTemplateForRender } from '@/utils/i18n'
import {
  Field,
  Button,
  Form,
  RadioGroup,
  Radio,
  DatetimePicker,
  Popup,
  Calendar,
  Toast,
  Icon,
  PullRefresh,
  Stepper,
  Switch,
  Picker,
  Dialog
} from 'vant'
import moment from 'moment'
import { faceAlignCrop, faceRotation } from '@/utils/img/faceAlignCrop'
Vue.use(Icon)
Vue.use(Field)
Vue.use(Button)
Vue.use(Form)
Vue.use(Radio)
Vue.use(Toast)
Vue.use(RadioGroup)
Vue.use(DatetimePicker)
Vue.use(Popup)
Vue.use(Calendar)
Vue.use(PullRefresh)
Vue.use(Stepper)
Vue.use(Switch)
Vue.use(Picker)
Vue.use(Dialog)
export default {
  name: 'NewInvitation',
  activated() {
    console.log('PageA 被激活')
    if (this.$route.query.visitorId) {
      this.user = this.$route.query.shareId
        ? {
          name: decodeURIComponent(this.$route.query.name),
          id: this.$route.query.id,
          companyId: this.$route.query.companyId,
          companyCode: this.$route.query.companyCode,
        }
        : JSON.parse(localStorage.getItem('user'))
      this.interviewee = this.user
      this.ifRobot(this.user.companyId)
      this.getUsers(this.user.companyId)
      this.photo = uploadAvatar
      if (this.$route.query.shareId) {
        this.shareId = this.$route.query.shareId
      } else {
        this.getdateOverlap()
        this.shareId = ''
      }
      if (window.injectData && window.injectData.source == 'NewWorkApp') {
        this.sourceIsH5 = false
      }
    } else {
    }
  },
  deactivated() {
    console.log('PageA 被缓存')
  },
  created() {
    if (this.signInTypeList.length > 0) {
      this.signInType = this.$route.query.registerMode ? this.$route.query.registerMode : this.signInTypeList[0].value
    }
    console.log(this.radiobtnDefault) // 检查图片路径是否正确
    console.log(this.radiobtnCheck)
  },
  components: {
    NavBar,
    Card,
    DateRangePicker,
  },
  data() {
    return {
      showHyvisible: false,
      Conference: '',
      showConference: false,
      IsSubscribe: false,
      user: {},
      ConferenceColumns: ['123'],
      interviewee: {},
      date: [dayjs().add(1, 'hour').startOf('hour'), dayjs().add(2, 'hour').startOf('hour')],
      radio: '',
      visitorName: '',
      visitorMobile: '',
      intervieweeMobile: '',
      purposeList: [],
      visitorDate: '',
      userList: [],
      // visitTime: '',
      visitStartTime: dayjs().format('HH:mm'),
      visitEndTime: dayjs().add(1, 'hour').format('HH:mm'),
      visitorCompany: '',
      visitorNumber: 1,
      showTime: false,
      showEndTime: false,
      showDate: false,
      showSelect: true,
      tmpTime: '',
      tmpEndTime: '',
      searchList: [],
      searchMsg: '',
      photo: null,
      visitorPhoto: '',
      option: {
        fixedNumber: [9, 16],
        confirmButtonBackgroundColor: '#009BFF',
        cancelButtonText: this.$t('取消'),
        confirmButtonText: this.$t('确认'),
      },
      isLoading: false,
      showRobot: false,
      showPT: false,
      PTList: [],
      ifSending: false,
      robotPT: null,
      tmpRobotPT: null,
      sourceIsH5: true,
      isConfirm: false,
      signInList: [],
      signInType: 'callReceptionist',
      showSignIn: false,
      signInTypeList: [],
      signInResult: '',
      robotGuide: '',
      showGuide: false,
      showGuidePopup: false,
      guideList: [],
      guideResult: '',
      tmpRobotGuide: null,
      currentAddress: null,
      addressList: [],
      showAddress: false, //新UI
      showPersonnel: false, //新UI
      showPurpose: false, //新UI
      adderssResult: null, //选中的地址
      currentAdderssResult: null, //选中的地址
      currentSignInResult: null, //选中的接待方式
      currentPT: null, //选中的接待目的地
      currentGuide: null, //选中的讲解路线
      currentConferenceResult: null, //选中的预约会议室
      personnelResult: {}, //选中的接待人
      purposeResult: {}, //选中的到访目的
      ifUpdate: false,
      buttonText: null,
      intervieweeName: null,
      status: null,
      invitationCode: null,
      title: '',
      IsSubscribeTitle: null,
      ConferenceId: '',
      timeUnit: 0,
      appointmentInterval: null,
      scheduledEndTime: null,
      scheduledMaxTime: 0,
      statusLoading: false, // 是否可预约loading
      formattedEndTime: '',
      formIcon,
      show: false,
      moreSettings: false, //更多设置
      radiobtnDefault: require('@/assets/images/Radiobtn_default.svg'),
      radiobtnCheck: require('@/assets/images/Radiobtn_check.svg'),
      startTime: null, // 计算后的时间
      endTime: null,
      nameError: '',
      mobileError: '',
      mobileIntervieweeError: '',
      shareId: '',
      showToast: false,
      showInvitationInfo: true,
      receptionImgList: [
        {
          text: 'callReceptionist',
          value: require('@/assets/images/call.svg'),
        },
        {
          text: 'pointGuide',
          value: require('@/assets/images/lead.svg'),
        },
        {
          text: 'routeGuide',
          value: require('@/assets/images/explain.svg'),
        },
        {
          text: 'noGuide',
          value: require('@/assets/images/open.svg'),
        },
      ],
      isCrossDayVisit: false,
    }
  },

  methods: {
    async IsDoOk() {
      this.showInvitationInfo = true
      this.showToast = false
    },
    toShowToast() {
      this.showToast = true
    },
    callI18nTemplate(key) {
      return I18nTemplateForRender(key); // 调用它，如果它是一个方法
    },
    getValueByText(targetText) {
      const match = this.receptionImgList.find(
        (option) => option.text === targetText
      )
      return match ? match.value : null // 如果找不到，返回 null
    },
    validateName() {
      if (!this.visitorName) {
        this.nameError = this.$t('访客姓名不能为空')
      } else {
        this.nameError = ''
      }
    },
    intervieweedateMobile() {
      const phoneRegex = /^1[3-9]\d{9}$/
      if (!this.intervieweeMobile) {
        this.mobileIntervieweeError = ''
      } else if (!phoneRegex.test(this.intervieweeMobile)) {
        this.mobileIntervieweeError = this.$t('请输入正确的电话号码')
      } else {
        this.mobileIntervieweeError = ''
      }
    },
    validateMobile() {
      const phoneRegex = /^1[3-9]\d{9}$/
      if (!this.visitorMobile) {
        this.mobileError = this.$t('电话号码不能为空')
      } else if (!phoneRegex.test(this.visitorMobile)) {
        this.mobileError = this.$t('请输入正确的电话号码')
      } else {
        this.mobileError = ''
      }
    },
    //点击接待人回调函数，用于弹出接待人选择窗口和获取接待人数据
    onPersonnel() {
      if (this.$route.query.shareId) {
        return
      }
      this.showPersonnel = true
      this.getSearchList()
    },
    onPT() {
      if (this.$route.query.shareId) {
        return
      }
      this.currentPT = this.robotPT
      this.showPT = true
    },
    onGuidePopup() {
      if (this.$route.query.shareId) {
        return
      }
      this.currentGuide = this.robotGuide
      this.showGuidePopup = true
    },
    //点击地点
    onAddress() {
      if (this.$route.query.shareId) {
        return
      }
      this.currentAdderssResult = this.adderssResult
      this.showAddress = true
    },
    //点击到访目的
    onPurpose() {
      this.purposeResult = this.radio
      this.showPurpose = true
    },
    //点击接待方式
    onSignIn() {
      if (this.$route.query.shareId) {
        return
      }
      this.currentSignInResult = this.signInType
      this.showSignIn = true
    },
    //点击预约会议室
    onConference() {
      if (this.ConferenceColumns.length == 0) {
        return
      }
      this.currentConferenceResult = this.ConferenceId
      this.showHyvisible = true
    },
    //地点确认回调
    confirmSelection() {
      const data =
        this.addressList?.length > 0 &&
        this.addressList.find((item) => item.id == this.currentAdderssResult)
      this.currentAddress = data.address
      this.adderssResult = this.currentAdderssResult
      this.showAddress = false
    },
    //接待方式确认回调
    signInSelection() {
      this.signInResult = this.currentSignInResult
      this.signInType = this.currentSignInResult
      this.showRobot =
        this.currentSignInResult == 'pointGuide' ? true : false
      this.showGuide =
        this.currentSignInResult == 'routeGuide' ? true : false

      this.showSignIn = false
    },
    //预约会议室确认回调
    conferenceSelection() {
      const data =
        this.ConferenceColumns?.length > 0 &&
        this.ConferenceColumns.find(
          (item) => item.id == this.currentConferenceResult
        )
      this.Conference = data.text
      this.ConferenceId = data.id
      this.getdateOverlap() //选择会议室后，也许校验是否有预约
      this.showHyvisible = !!0
    },
    //拜访目的确认回调
    purposeSelection() {
      this.radio = this.purposeResult
      this.showPurpose = false
    },
    triggerFileInput() {
      this.$refs.fileInput.click()
    },
    async imgChange({ target }) {
      this.$refs.cropper.loadFile(await faceRotation(target.files[0], 0))
      target.value = ''
    },
    setHyValue(e) {
      this.Conference = e.text
      this.ConferenceId = e.id
      this.getdateOverlap() //选择会议室后，也许校验是否有预约
      this.showHyvisible = !!0
    },
    dateChange() {
      this.showDate = true
    },
    onSubmit() {
      console.log('onSubmit')
    },
    handleUpdateTime({ timeArray, isCrossDayVisit }) {
      this.date = timeArray
      this.visitStartTime = dayjs(timeArray[0]).format('HH:mm')
      this.visitEndTime = dayjs(timeArray[1]).format('HH:mm')
      console.log(this.date, this.visitStartTime, this.visitEndTime)

      // 2. 记录是否跨天
      this.isCrossDayVisit = isCrossDayVisit

      // 3. 如果跨天则禁止会议室预约，并自动关闭
      if (isCrossDayVisit && this.IsSubscribe) {
        this.IsSubscribe = false
      }

      // 处理接收到的时间数据
    },
    async setBookAppointment(
      robotLocation,
      robotWorkspaceName,
      registerMode,
      robotGuide
    ) {
      // let startTime =
      //   new Date().getFullYear() +
      //   '-' +
      //   this.date +
      //   ' ' +
      //   this.setTime(this.visitStartTime, 1) +
      //   ':00'
      // let endTime =
      //   new Date().getFullYear() +
      //   '-' +
      //   this.date +
      //   ' ' +
      //   this.setTime(this.visitEndTime, 1) +
      //   ':00'
      const startTimes = this.setTime(this.visitStartTime, 10)
      const endTimes = this.setTime(this.visitEndTime, 2)
      const newStartTime =
        new Date().getFullYear() +
        '-' +
        dayjs(this.date[0]).format('MM-DD') +
        ' ' +
        startTimes +
        ':' +
        '00'
      const newEndTime =
        new Date().getFullYear() + '-' + dayjs(this.date[1]).format('MM-DD') + ' ' + endTimes + ':' + '00'
      const cha = moment(newEndTime).diff(moment(newStartTime), 'minutes')

      let data = {
        address: this.currentAddress,
        developerId: this.user.companyId * 1,
        appointmentStaff: this.interviewee.id, //预约人
        meetingPeopleId: this.interviewee.id,
        companyId: this.user.companyId,
        // replaceAppointmentStaff: 0, //被预约人
        meetingRoomId: this.ConferenceId,
        multiMeetingRoomIds: [this.ConferenceId],
        // appointmentPeriod: cha,
        appointmentTopic: this.$t('{slot1}的访客接待', {
          slot1: this.user.name,
        }),
        // visitPurpose: this.radio,
        appointmentStartTime: newStartTime,
        appointmentEndTime: newEndTime,
        // peopleId: this.interviewee.id,
        // relationMeetingId: 0,
        repeatType: 'single',
        otherPeopleRecord: JSON.stringify([
          {
            name: this.visitorName,
            mobile: this.visitorMobile,
            email: '',
          },
        ]),
        robotLocation: robotLocation || '',
        robotWorkspaceName: robotWorkspaceName || '',
        source: 'H5',
        registerMode: registerMode ?? '',
        robotGuide: robotGuide || '',
        remindTime: this.timeUnit,
        // visitId: null,
      }
      const res = await bookAppointment(data)
    },
    async getdateOverlap() {
      let startTime =
        new Date().getFullYear() +
        '-' +
        dayjs(this.date[0]).format('MM-DD') +
        ' ' +
        this.visitStartTime +
        ':00'
      let endTime =
        new Date().getFullYear() +
        '-' +
        dayjs(this.date[1]).format('MM-DD') +
        ' ' +
        this.visitEndTime +
        ':00'
      const res = await queryAppointmentList({
        companyId: this.user.companyId,
        meetingRoomId: this.ConferenceId,
        date: new Date().getFullYear() + '-' + dayjs(this.date[0]).format('MM-DD'),
      })
      let isOk = true
      if (this.IsSubscribe) {
        const limitStart = moment(this.appointmentInterval, 'HH:mm')
        const limitEnd = moment(this.scheduledEndTime, 'HH:mm')
        const resultStart = this.setTime(this.visitStartTime, 10)
        const resultEnd = this.setTime(this.visitEndTime, 2)
        const dateEnd = moment(resultEnd, 'HH:mm')
        const dateStart = moment(resultStart, 'HH:mm')
        if (limitEnd < dateEnd) {
          Toast.fail(
            this.$t('预约时间最晚为 {slot1} ,您已超出,请重新选择', {
              slot1: this.scheduledEndTime,
            })
          )
          isOk = false
          return
        }
        if (limitStart > dateStart) {
          Toast.fail(
            this.$t('预约时间最早为 {slot1} ,您已提前,请重新选择', {
              slot1: this.appointmentInterval,
            })
          )
          isOk = false
          return
        }
        if (this.scheduledMaxTime != 24) {
          const limitCha = this.scheduledMaxTime * 60
          // console.log('限制差距Cha', limitCha)
          const startTimes = this.setTime(this.visitStartTime, 10)
          const endTimes = this.setTime(this.visitEndTime, 2)
          const newStartTime =
            new Date().getFullYear() +
            '-' +
            dayjs(this.date[0]).format('MM-DD') +
            ' ' +
            startTimes +
            ':' +
            '00'
          const newEndTime =
            new Date().getFullYear() +
            '-' +
            dayjs(this.date[1]).format('MM-DD') +
            ' ' +
            endTimes +
            ':' +
            '00'
          const cha = moment(newEndTime).diff(moment(newStartTime), 'minutes')
          // console.log('实际差距=多少分钟', cha)
          if (cha > limitCha) {
            Toast.fail(
              this.$t('会议支持最长预约时间 {slot1}小时 ', {
                slot1: this.scheduledMaxTime,
              })
            )
            isOk = false
            return
          }
        }
      }
      if (isOk == false) {
        return
      }

      if (res.length) {
        let status = false
        res.forEach((item) => {
          if (item.actualEndTime) {
            const actualEnd = new Date(item.actualEndTime)
            const minutes = actualEnd.getMinutes()
            let roundedMinutes
            if (minutes < 15) {
              roundedMinutes = 15
            } else if (minutes < 30) {
              roundedMinutes = 30
            } else if (minutes < 45) {
              roundedMinutes = 45
            } else {
              roundedMinutes = 0
              actualEnd.setHours(actualEnd.getHours() + 1)
            }
            actualEnd.setMinutes(roundedMinutes)
            this.formattedEndTime = `${actualEnd.getFullYear()}-${(
              actualEnd.getMonth() + 1
            )
              .toString()
              .padStart(2, '0')}-${actualEnd
                .getDate()
                .toString()
                .padStart(2, '0')} ${actualEnd
                  .getHours()
                  .toString()
                  .padStart(2, '0')}:${actualEnd
                    .getMinutes()
                    .toString()
                    .padStart(2, '0')}:00`
            if (
              dayjs(this.formattedEndTime).format('YYYY-MM-DD HH:mm:ss') >
              dayjs(startTime).format('YYYY-MM-DD HH:mm:ss') &&
              dayjs(item.appointmentStartTime).format('YYYY-MM-DD HH:mm:ss') <
              dayjs(endTime).format('YYYY-MM-DD HH:mm:ss')
            ) {
              status = true
            }
            if (
              dayjs(this.formattedEndTime).format('YYYY-MM-DD HH:mm:ss') ==
              dayjs(endTime).format('YYYY-MM-DD HH:mm:ss') &&
              dayjs(item.appointmentStartTime).format('YYYY-MM-DD HH:mm:ss') ==
              dayjs(startTime).format('YYYY-MM-DD HH:mm:ss')
            ) {
              status = true
            }
          } else {
            if (
              dayjs(item.appointmentEndTime).format('YYYY-MM-DD HH:mm:ss') >
              dayjs(startTime).format('YYYY-MM-DD HH:mm:ss') &&
              dayjs(item.appointmentStartTime).format('YYYY-MM-DD HH:mm:ss') <
              dayjs(endTime).format('YYYY-MM-DD HH:mm:ss')
            ) {
              status = true
            }
            if (
              dayjs(item.appointmentEndTime).format('YYYY-MM-DD HH:mm:ss') ==
              dayjs(endTime).format('YYYY-MM-DD HH:mm:ss') &&
              dayjs(item.appointmentStartTime).format('YYYY-MM-DD HH:mm:ss') ==
              dayjs(startTime).format('YYYY-MM-DD HH:mm:ss')
            ) {
              status = true
            }
          }
        })
        if (status == true) {
          this.IsSubscribeTitle = this.$t('不可预约')
        } else {
          this.IsSubscribeTitle = this.$t('可预约')
        }
      } else {
        this.IsSubscribeTitle = this.$t('可预约')
      }
      this.statusLoading = false
    },

    async getMeetingRoom() {
      var companyId = this.user.companyId
      const res = await getMeetingRoomByArea({
        developerId: companyId,
        workspaceId: '',
      })
      this.ConferenceColumns = res.map((p) => {
        return {
          text: p.name,
          ...p,
        }
      })

      this.Conference = this.ConferenceColumns[0].text
      this.ConferenceId = this.ConferenceColumns[0].id // 点击预约同时段 默认第一个
      const item = this.ConferenceColumns.find((item) => {
        return this.tmpRobotPT.includes(item.name)
      })
      if (!!item) {
        this.setHyValue(item)
      }
      this.getdateOverlap()
    },

    SubscribeChange(e) {
      // 检查是否跨天
      if (this.isCrossDayVisit && !this.IsSubscribe) {
        Toast.fail('跨天预约不支持会议室预约')
        return
      }

      if (!this.date?.length && !this.IsSubscribe) {
        Toast.fail(this.$t('请选择到访日期'))
        return
      }
      console.log('e', e)
      this.IsSubscribe = !this.IsSubscribe
      if (e == true) {
        this.statusLoading = true
        this.getMeetingRoom()
        getMeetingRoomConfig({ developerId: this.user.companyId }).then(
          (res) => {
            this.timeUnit = res.timeUnit
            this.appointmentInterval = res.scheduledStartTime
            this.scheduledEndTime = res.scheduledEndTime
            this.scheduledMaxTime = res.scheduledMaxTime
            this.getdateOverlap()
          }
        )
      } else {
        this.ConferenceId = ''
      }
    },

    setTime(time, type) {
      const timeUnit = this.timeUnit
      var data
      // let dataTime = new Date().getFullYear() + '-' + this.date + ' ' + time
      // 取 this.date 数组第 0 个 dayjs
      let baseDate = dayjs(this.date[0])

      // 格式化成 YYYY-MM-DD
      let dateStr = baseDate.format('YYYY-MM-DD')

      // 拼接成完整时间
      let dataTime = `${dateStr} ${time}`
      if (type == 1) {
        data = dayjs(dataTime).subtract(5, 'minute').format('HH:mm')
      } else if (type == 10) {
        dataTime = dayjs(dataTime).format('YYYY-MM-DD HH:mm')
        let arr = dataTime.split(' ')[1].split(':'),
          fen = parseInt(arr[arr.length - 1]),
          hour = parseInt(arr[arr.length - 2])
        let s = Math.floor(fen / timeUnit) * timeUnit
        dataTime = dataTime.split(' ')[0] + ` ${hour}:${s}`
        data = dayjs(dataTime).format('HH:mm')
        return data
      } else {
        dataTime = dayjs(dataTime).format('YYYY-MM-DD HH:mm')
        let arr = dataTime.split(' ')[1].split(':'),
          fen = parseInt(arr[arr.length - 1]),
          hour = parseInt(arr[arr.length - 2])

        if (fen > 45) {
          hour += 1
          fen = 0
          dataTime = dataTime.split(' ')[0] + ` ${hour}:${fen}`
          data = dayjs(dataTime).format('HH:mm')
        } else {
          fen = Math.ceil(fen / timeUnit) * timeUnit
          if (fen > 45) {
            hour += 1
            fen = 0
          }
          dataTime = dataTime.split(' ')[0] + ` ${hour}:${fen}`
          data = dayjs(dataTime).format('HH:mm')
        }
      }
      return data
    },
    ConferenceConfirm(e) {
      this.showConference = false
      this.Conference = e.text
      this.ConferenceId = e.id
      this.getdateOverlap() //选择会议室后，也许校验是否有预约
    },
    toVisitors() {
      this.$store.state.visitorState = 'pre'
      this.$router.push('/visitors')
    },
    toFaceTips() {
      this.$router.push('/faceTips')
    },
    toSendInvitation() {
      let spaceName = ''
      let robotLocation = ''
      if (this.signInType == 'pointGuide') {
        if (!this.currentPT) {
          Toast.fail(this.$t('请选择目的地'))
          return
        } else {
          spaceName = this.currentPT && this.currentPT.split('/')[0]
          robotLocation = this.currentPT && this.currentPT.split('/')[1]
        }
      }
      if (this.signInType == 'routeGuide') {
        if (!this.robotGuide) {
          Toast.fail(this.$t('请选择讲解路线'))
          return
        } else {
          spaceName = this.robotGuide
          robotLocation = this.guideList.filter(
            (item) => item.name == this.robotGuide
          )[0].id
        }
      }
      if (isMobileType.iOS()) {
        window.location.href = `${window.location.origin}/newwork-h5/SendInvitation/?intervieweeId=${this.interviewee.id}&address=${this.currentAddress}&registerMode=${this.signInType}&intervieweeName=${this.user.companyId == 303 ? this.intervieweeMobile : this.intervieweeName}&spaceName=${this.spaceName}&robotLocation=${this.robotLocation}`
      } else {
        this.$router.push({ path: '/SendInvitation', query: { intervieweeId: this.interviewee.id, address: this.currentAddress, registerMode: this.signInType, intervieweeName: this.user.companyId == 303 ? this.intervieweeMobile : this.intervieweeName, spaceName: spaceName, robotLocation: robotLocation } })
      }
    },
    mobileTest() {
      return /^1[3-9]\d{9}$/.test(this.visitorMobile)
    },
    addNum() {
      this.visitorNumber = this.visitorNumber * 1 + 1
    },
    reduceNum() {
      if (this.visitorNumber <= 1) return
      this.visitorNumber = this.visitorNumber - 1
    },
    async getPurposeList(str) {
      // const res1 = await getDictionary(str)
      // 和后端沟通查询的固定的字典表，这里直接固定
      const res = [
        {
          "id": 31,
          "value": this.$t('拜访'),
          "itemKey": "VISITOR_PURPOSE"
        },
        {
          "id": 32,
          "value": this.$t('面试'),
          "itemKey": "VISITOR_PURPOSE"
        },
        {
          "id": 33,
          "value": this.$t('商务合作'),
          "itemKey": "VISITOR_PURPOSE"
        },
        {
          "id": 34,
          "value": this.$t('考察'),
          "itemKey": "VISITOR_PURPOSE"
        },
        {
          "id": 35,
          "value": this.$t('其他'),
          "itemKey": "VISITOR_PURPOSE"
        }
      ]
      this.purposeList = res
      if (this.$route.query.visitorId) {
        this.title = this.$t('编辑')
        this.getInfo(this.$route.query.visitorId)
      } else {
        this.radio = this.callI18nTemplate(res[0].value)
        let hour = dayjs(new Date()).format('HH') * 1 + 1
        if (hour <= 9) {
          hour = '0' + hour
        }
        hour == 24 && (hour = '00')
        this.visitStartTime = hour + ':00'
        this.visitEndTime = hour * 1 + 1 + ':00'
        this.tmpTime = this.visitStartTime
        this.tmpEndTime = this.visitEndTime
        this.intervieweeName = this.shareId ? this.$route.query.intervieweeName : this.user.name
        this.intervieweeMobile = this.shareId ? this.$route.query.intervieweeName : null
        this.buttonText = this.$t('确定')
        this.title = this.shareId
          ? this.$t('访客信息登记')
          : this.$t('新建邀约')
      }
    },
    choseTime() {
      this.visitStartTime = this.tmpTime
      this.showTime = false
      this.getdateOverlap()
    },
    choseDate(date) {
      this.date = dayjs(date).format('MM-DD')
      this.visitorDate = date
      this.showDate = false
      this.getdateOverlap()
    },
    formatter(day) {
      if (
        dayjs(day.date).format('YYYY-MM-DD') ==
        dayjs(new Date()).format('YYYY-MM-DD')
      ) {
        day.className = 'date-border'
      }
      return day
    },
    selectInterviewee(v) {
      this.searchList = []
      let arr = this.userList.filter((item) => {
        if (!item.name) return
        return item.name.includes(v)
      })
      this.searchList = arr
    },
    addInterviewee() {
      this.interviewee = this.personnelResult
      this.intervieweeName = this.personnelResult.name
      this.showPersonnel = false
      this.searchMsg = ''
      this.searchList = []
    },
    async getSearchList() {
      try {
        const res = await getUserList({ companyId: this.user.companyId })
        let arr = [...res]
        let Arr = arr.filter((item) => {
          if (!item.name) return
          return item.name
        })
        this.searchList = Arr
      } catch (error) {
        console.log(error)
      }
    },
    async getUsers(companyId) {
      try {
        const res = await getUserList({ companyId })
        let arr = [...res]
        this.userList = arr
      } catch (error) {
        console.log(error)
      }
    },
    goBackIndex() {
      this.searchMsg = ''
      this.searchList = []
      this.showSelect = true
    },
    async onConfirm() {
      if (this.isLoading) return
      this.validateName()
      this.validateMobile()
      if (this.nameError || this.mobileError || this.mobileIntervieweeError) {
        return
      }

      if (this.IsSubscribeTitle == this.$t('不可预约') && this.IsSubscribe) {
        Toast.fail(this.$t('当前时间段不可预约'))
        return
      }
      if (!this.intervieweeName && this.user.companyId != 303) {
        Toast.fail(this.$t('请输入被访人'))
        return
      }
      if (!this.radio) {
        Toast.fail(this.$t('请选择来访目的'))
        return
      }

      if (!this.date) {
        Toast.fail(this.$t('请选择来访日期'))
        return
      }
      if (this.ifSending) {
        Toast.fail(this.$t('人脸识别照片上传中,请稍等'))
        return
      }
      let visitTime =
        dayjs(this.visitorDate).format('YYYY-MM-DD') + ' ' + this.visitStartTime
      if (
        dayjs(visitTime).valueOf() < dayjs().valueOf() &&
        !this.$route.query.visitorId
      ) {
        Toast.fail(this.$t('到访时间/日期无效'))
        return
      }
      let visitEndTime =
        dayjs(this.visitorDate).format('YYYY-MM-DD') + '' + this.visitEndTime
      if (dayjs(visitTime).valueOf() >= dayjs(visitEndTime).valueOf()) {
        Toast.fail(this.$t('结束时间需大于起始时间'))
        return
      }
      if (this.signInType === 'pointGuide' && !this.robotPT) {
        Toast.fail(this.$t('请选择目的地'))
        return
      }
      if (this.signInType === 'routeGuide' && !this.robotGuide) {
        Toast.fail(this.$t('请选择讲解路线'))
        return
      }
      let registerMode = undefined
      let robotGuide = undefined
      let robotLocation = undefined
      let robotWorkspaceName = undefined

      if (this.signInType) {
        switch (this.signInType) {
          case 'callReceptionist':
            registerMode = ''
            break
          case 'noGuide':
            registerMode = 'noGuide'
            break
          case 'pointGuide':
            registerMode = 'pointGuide'
            robotLocation = this.currentPT && this.currentPT.split('/')[1]
            robotWorkspaceName = this.currentPT && this.currentPT.split('/')[0]
            break
          case 'routeGuide':
            registerMode = 'routeGuide'
            robotGuide = this.guideList.filter(
              (item) => item.name == this.robotGuide
            )[0].id
            break
        }
      }
      let isOk = true
      if (this.IsSubscribe) {
        const limitStart = moment(this.appointmentInterval, 'HH:mm')
        const limitEnd = moment(this.scheduledEndTime, 'HH:mm')
        const resultStart = this.setTime(this.visitStartTime, 10)
        const resultEnd = this.setTime(this.visitEndTime, 2)
        const dateEnd = moment(resultEnd, 'HH:mm')
        const dateStart = moment(resultStart, 'HH:mm')
        if (limitEnd < dateEnd) {
          Toast.fail(
            this.$t('预约时间最晚为 {slot1} ,您已超出,请重新选择', {
              slot1: this.scheduledEndTime,
            })
          )
          isOk = false
          this.IsSubscribeTitle = this.$t('不可预约')
          return
        }
        if (limitStart > dateStart) {
          Toast.fail(
            this.$t('预约时间最早为 {slot1} ,您已提前,请重新选择', {
              slot1: this.appointmentInterval,
            })
          )
          this.IsSubscribeTitle = this.$t('不可预约')
          isOk = false
          return
        }
        this.IsSubscribeTitle = this.$t('可预约')
        if (this.scheduledMaxTime != 24) {
          const limitCha = this.scheduledMaxTime * 60
          // console.log('限制差距Cha', limitCha)
          const startTimes = this.setTime(this.visitStartTime, 10)
          const endTimes = this.setTime(this.visitEndTime, 2)
          const newStartTime =
            new Date().getFullYear() +
            '-' +
            dayjs(this.date[0]).format('MM-DD') +
            ' ' +
            startTimes +
            ':' +
            '00'
          const newEndTime =
            new Date().getFullYear() +
            '-' +
            dayjs(this.date[1]).format('MM-DD') +
            ' ' +
            endTimes +
            ':' +
            '00'
          const cha = moment(newEndTime).diff(moment(newStartTime), 'minutes')
          // console.log('实际差距=多少分钟', cha)
          if (cha > limitCha) {
            Toast.fail(
              this.$t('会议支持最长预约时间 {slot1}小时 ', {
                slot1: this.scheduledMaxTime,
              })
            )
            isOk = false
            return
          }
        }
        if (isOk == true) {
          try {
            await this.setBookAppointment(
              robotLocation,
              robotWorkspaceName,
              registerMode,
              robotGuide
            )
          } catch (error) {
            console.log(error)
            Toast.fail(this.$t('预约会议失败，请稍后再试'))
            return
          }
        }
      }
      if (isOk == false) {
        return
      }
      this.isConfirm = true
      let newStartTime
      let newEndTime
      if (this.IsSubscribe) {
        const startTime = this.setTime(this.visitStartTime, 10)
        const endTime = this.setTime(this.visitEndTime, 2)
        newStartTime =
          new Date().getFullYear() + '-' + dayjs(this.date[0]).format('MM-DD') + ' ' + startTime
        newEndTime = new Date().getFullYear() + '-' + dayjs(this.date[1]).format('MM-DD') + ' ' + endTime
      } else {
        newStartTime =
          new Date().getFullYear() + '-' + dayjs(this.date[0]).format('MM-DD') + ' ' + this.visitStartTime
        newEndTime =
          new Date().getFullYear() + '-' + dayjs(this.date[1]).format('MM-DD') + ' ' + this.visitEndTime
      }

      let data = this.shareId
        ? {
          address: this.currentAddress,
          developerId: this.user.companyId * 1,
          interviewee: this.interviewee.id,
          intervieweeMobile: this.intervieweeMobile,
          visitPurpose: I18nTemplateForSubmit[this.radio],
          visitTime: newStartTime,
          visitEndTime: newEndTime,
          visitorCompany: this.visitorCompany,
          visitorMobile: this.visitorMobile,
          visitorName: this.visitorName,
          visitorPhoto: this.visitorPhoto,
          visitAcceptedStatus: this.visitAcceptedStatus,
          visitorNumber: this.visitorNumber,
          shareId: this.shareId + ':' + this.user.id,
          source: 'link',
          inviteUrl: window.location.origin + this.$route.fullPath,
          registerMode: registerMode ?? '',
          robotGuide: robotGuide || '',
          robotLocation: robotLocation || '',
          robotWorkspaceName: robotWorkspaceName || '',
          source: 'H5',
        }
        : {
          address: this.currentAddress,
          meetingRoomId: this.ConferenceId,
          companyId: this.user.companyId,
          developerId: this.user.companyId * 1,
          interviewee: this.interviewee.id,
          intervieweeMobile: this.intervieweeMobile,
          visitPurpose: I18nTemplateForSubmit[this.radio],
          visitTime: newStartTime,
          visitEndTime: newEndTime,
          visitorCompany: this.visitorCompany,
          visitorMobile: this.visitorMobile,
          visitorName: this.visitorName,
          visitorPhoto: this.visitorPhoto,
          visitAcceptedStatus: this.visitAcceptedStatus,
          visitorNumber: this.visitorNumber,
          otherPeopleRecord: [
            {
              name: this.visitorName,
              mobile: this.visitorMobile,
            },
          ],
          robotLocation: robotLocation || '',
          robotWorkspaceName: robotWorkspaceName || '',
          source: 'H5',
          registerMode: registerMode ?? '',
          robotGuide: robotGuide || '',
          // visitId: null,
        }
      this.isLoading = true
      try {
        if (this.ifUpdate) {
          await visitorUpdate({
            ...data,
            id: this.visitId,
            status: this.status,
            invitationCode: this.invitationCode,
          })
          Toast.success(this.$t('修改成功'))
          this.$router.push('/visitors')
          this.isLoading = false
        } else {
          const id = await visitorSave({
            ...data,
          })
          Toast.success(this.$t('新建邀约成功'))

          const visitId = await getVisit({ id })

          if (window.injectData && window.injectData.source == 'NewWorkApp') {
            this.sourceIsH5 = false
            this.$store.state.visitorState = 'pre'
            this.$router.push('/visitors')
          } else {
            if (this.shareId) {
              this.$router.push({
                path: `/visitorInvitation`,
                query: {
                  id: this.user.id,
                  shareId: this.shareId,
                  companyCode: this.user.companyCode,
                  companyId: this.user.companyId,
                  localLanguage: this.$route.query.localLanguage ? this.$route.query.localLanguage : 'zh-CN'
                },
              })
            } else {
              this.$router.replace({
                path: `/visitorInfo`,
                query: { id: visitId.id },
              })
            }
          }
          this.isLoading = false
        }
      } catch (error) {
        this.isLoading = false
        console.log('异常', error)
        Toast.fail(error.response.data)
      } finally {
        this.isConfirm = false
      }
    },
    async getFile(data) {
      try {
        console.log(data, 'data')
        this.ifSending = true
        const file = await faceAlignCrop(data)
        const formData = new FormData()
        formData.append('file', file)

        const res = await uploadFace(formData)
        this.visitorPhoto = res
        this.photo = res
        this.ifSending = false
      } catch (error) {
        this.ifSending = false
        this.photo = uploadAvatar
        Toast.fail(error?.message ?? this.$t('图片上传失败'))
      }
    },
    getbase64Data(data) {
      this.photo = data
    },
    async onRefresh() {
      await this.getPurposeList('VISITOR_PURPOSE')
      setTimeout(() => {
        Toast(this.$t('刷新成功'))
        this.isLoading = false
      }, 500)
    },
    async ifRobot(companyId) {
      const res = await getRobotWork(companyId)
      let arr = []
      res && arr.push({ name: 'callReceptionist', value: '' })
      res.leadingServiceStatus &&
        arr.push({
          name: 'noGuide',
          value: 'leadingServiceStatus',
        })
      res.leadingServiceSecond &&
        arr.push({
          name: 'pointGuide',
          value: 'leadingServiceSecond',
        })
      res.leadingServiceThird &&
        arr.push({
          name: 'routeGuide',
          value: 'leadingServiceThird',
        })
      const targetItem = arr?.length > 0 && arr.find(item => item.name === 'noGuide')
      const filteredActions =
        (arr?.length > 0 && arr.filter(item => item.name !== 'noGuide')) || []

      if (targetItem) {
        filteredActions.unshift(targetItem)
      }
      this.signInTypeList = filteredActions
      if (filteredActions.length > 0) {
        this.signInType = filteredActions[0].name
      }
      if (res.pointPositions) {
        this.PTList = res.pointPositions.map((item) => {
          return { name: item }
        })
        // const defaultPT = this.PTList.length > 0 ? this.PTList[0].name : ''
        // this.tmpRobotPT = defaultPT
        // this.robotPT = defaultPT
        // this.result = defaultPT
      }
      if (res.robotGuideName) {
        this.guideList = res.robotGuideName.split(',').map((item) => {
          return { id: item.split(':')[0], name: item.split(':')[1] }
        })
      }
      this.getAddress(this.user.companyId)
      // if (this.showRobot) this.getSerial()
    },
    confirmRobot() { },
    confirmRobotGuide() { },
    selectPT() {
      this.tmpRobotPT = this.currentPT
      this.robotPT = this.tmpRobotPT
      const item = this.ConferenceColumns.find((item) => {
        return this.tmpRobotPT.includes(item.name)
      })
      if (!!item) {
        this.setHyValue(item)
      }
      this.showPT = false
    },
    selectGuide() {
      this.tmpRobotGuide = this.currentGuide
      this.robotGuide = this.tmpRobotGuide
      this.showGuidePopup = false
    },
    selectSignIn(val) {
      this.signInType = val.name
      val.value == 'leadingServiceSecond'
        ? (this.showRobot = true)
        : (this.showRobot = false)
      val.value == 'leadingServiceThird'
        ? (this.showGuide = true)
        : (this.showGuide = false)
      this.showSignIn = false
    },
    async getAddress(companyId) {
      const res = await getVisitaddress(companyId)
      console.log(res)

      if (res?.length > 0) {
        this.addressList = res
        if (this.$route.query.address) {
          this.currentAddress = this.$route.query.address
          this.adderssResult = res
            .filter(item => item.address === this.$route.query.address)
            .map(item => item.id);
        } else {
          this.currentAddress = res[0].address
          this.adderssResult = res[0].id
        }
      }
      this.getPurposeList('VISITOR_PURPOSE')
    },

    // selectAddress(val) {
    //   this.currentAddress = val.address
    //   // this.adderssResult = val.id
    //   // this.showAddress = false
    // },

    async getInfo(id) {
      const res = await getVisit({ id })
      this.visitId = res.id
      this.ifUpdate = true
      console.log(res)

      this.intervieweeName = res.intervieweeName
      this.interviewee.id = res.interviewee
      this.buttonText = this.$t('确认修改')
      this.visitorName = res.visitorName
      this.visitorMobile = res.visitorMobile
      this.intervieweeMobile = res.intervieweeMobile,
        this.radio = this.callI18nTemplate(res.visitPurpose)
      res.visitorPhoto && (this.photo = this.visitorPhoto = res.visitorPhoto)
      this.date = [dayjs(res.visitTime), dayjs(res.visitEndTime)]
      this.visitorDate = dayjs(res.visitTime).$d
      this.visitorNumber = res.visitorNumber
      this.visitorCompany = res.visitorCompany
      this.status = res.status
      this.invitationCode = res.invitationCode
      this.visitAcceptedStatus = res.visitAcceptedStatus
      this.visitStartTime = this.tmpTime = dayjs(res.visitTime).format('HH:mm')
      this.visitEndTime = this.tmpEndTime = dayjs(res.visitEndTime).format(
        'HH:mm'
      )

      const startDate = dayjs(res.visitTime).format('YYYY-MM-DD')
      const endDate = dayjs(res.visitEndTime).format('YYYY-MM-DD')
      this.isCrossDayVisit = startDate !== endDate;
      this.$nextTick(() => {
        this.startTime = res.visitTime
        this.endTime = res.visitEndTime
      })

      if (res.address && this.addressList.length > 0) {
        let curAddress = this.addressList.filter(
          (item) => item.address == res.address
        )[0]
        if (curAddress) {
          this.currentAddress = res.address
          this.adderssResult = curAddress.id
        }
      }
      if (res.registerMode && this.signInTypeList.length > 0) {
        let arr = this.signInTypeList.map((item) => item.name)
        switch (res.registerMode) {
          case '':
            if (arr.includes('callReceptionist')) {
              this.signInType = this.signInResult = 'callReceptionist'
            }
            break
          case 'noGuide':
            if (arr.includes('noGuide')) {
              this.signInType = this.signInResult = 'noGuide'
            }
            break
          case 'pointGuide':
            if (arr.includes('pointGuide')) {
              this.signInType = this.signInResult =
                'pointGuide'
              if (res.robotLocation && res.robotWorkspaceName) {
                let pt = this.PTList.filter(
                  (item) =>
                    item.name ==
                    res.robotWorkspaceName + '/' + res.robotLocation
                )[0]
                if (pt) {
                  this.robotPT = this.currentPT = pt.name
                }
              }
              this.showRobot = true
            }
            break
          case 'routeGuide':
            if (arr.includes('routeGuide')) {
              this.signInType = this.signInResult = 'routeGuide'
              this.showGuide = true
              let guide = this.guideList.filter(
                (item) => item.id == res.robotGuide
              )[0]
              if (guide) {
                this.robotGuide = this.guideResult = guide.name
              }
            }
            break
        }
      }
    },
    showPopup() {
      this.show = true
    },
    showMoreSettings() {
      this.moreSettings = true
    },
  },
  computed: {},
  mounted() {
    if (this.$route.query.shareId && this.$route.query.companyCode == '91510100MAEETWBL29') {
      this.showToast = true
      this.showInvitationInfo = false
    }
    this.user = this.$route.query.shareId
      ? {
        name: decodeURIComponent(this.$route.query.name),
        id: this.$route.query.id,
        companyId: this.$route.query.companyId,
        companyCode: this.$route.query.companyCode,
      }
      : JSON.parse(localStorage.getItem('user'))
    this.interviewee = this.user

    this.ifRobot(this.user.companyId)
    this.getUsers(this.user.companyId)
    this.photo = uploadAvatar
    if (this.$route.query.shareId) {
      this.shareId = this.$route.query.shareId
      this.interviewee = {
        id: parseInt(this.$route.query.intervieweeId),
        name: decodeURIComponent(this.$route.query.intervieweeName)
      }
      this.intervieweeName = decodeURIComponent(this.$route.query.intervieweeName)
      this.intervieweeMobile = decodeURIComponent(this.$route.query.intervieweeName)
      this.signInType = this.$route.query.registerMode
      this.currentAddress = decodeURIComponent(this.$route.query.address)
      if (this.$route.query.registerMode == 'pointGuide') {
        this.currentPT = decodeURIComponent(this.$route.query.spaceName) + '/' + decodeURIComponent(this.$route.query.robotLocation)
        this.showRobot = true
        this.robotPT = decodeURIComponent(this.$route.query.spaceName) + '/' + decodeURIComponent(this.$route.query.robotLocation)
      }
      if (this.$route.query.registerMode == 'routeGuide') {
        this.robotGuide = decodeURIComponent(this.$route.query.spaceName)
        this.currentGuide = decodeURIComponent(this.$route.query.spaceName)
        this.showGuide = true
      }
    } else {
      this.getdateOverlap()
      this.shareId = ''
    }
    if (window.injectData && window.injectData.source == 'NewWorkApp') {
      this.sourceIsH5 = false
    }
  },
  setup() {
    const checked = ref('1')
    return { checked }
  },
}
</script>
<style>
.van-field__left-icon {
  display: flex;
  align-items: center;
}
</style>
<style lang="less" scoped>
.newInvitation {
  height: 100%;
  background: #f2f4f7;

  .content {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding-top: 52px;
    padding-bottom: 40px;
    overflow: auto;

    .form-item {
      min-height: 52px;
      height: auto;
      width: 100%;
      position: relative;
      display: flex;
      padding-left: 16px;
      padding-right: 12px;
      border-bottom: #999999;

      .form-label {
        font-size: 16px;
        font-weight: 500;
        color: #1e2329;
        line-height: 24px;
        text-align: left;
        font-family: PingFangSC, PingFang SC;
        font-style: normal;
      }

      .form-label-purpose {
        font-size: 16px;
        font-weight: normal;
        color: #1e2329;
        line-height: 24px;
        text-align: left;
        font-family: PingFangSC, PingFang SC;
        font-style: normal;
      }

      .form-icon {
        width: 20px;
        height: 20px;
      }

      .form-tips {
        height: 24px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #707a8a;
        line-height: 24px;
        text-align: center;
        font-style: normal;
        margin-left: -30px;
        margin-top: 4px;

        span {
          color: #eaaa5c;
        }
      }

      .form-avatar {
        width: 48px;
        height: 48px;
      }

      .form-number {
        width: 114px;
        height: 28px;
        background: #ffffff;
        border-radius: 14px;
        border: 1px solid #e2e8f6;
      }

      .time-period {
        height: 22px;
        display: flex;
        justify-content: space-between;

        .time-value {
          width: 100px;
          height: 22px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 16px;
          color: #1e2329;
          line-height: 24px;
          text-align: left;
          font-style: normal;
        }

        .time-type {
          height: 22px;
          border-radius: 6px;
          border: 1px solid #0ecb81;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #0ecb81;
          line-height: 22px;
          text-align: center;
          font-style: normal;
          padding: 0 8px;
        }

        .time-type-no {
          padding: 0 2px;
          height: 22px;
          border-radius: 6px;
          border: 1px solid #f6465d;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #f6465d;
          line-height: 22px;
          text-align: center;
          font-style: normal;
          padding: 0 8px;
        }
      }
    }

    /deep/.van-stepper__minus {
      width: 32px !important;
      background: #ffffff !important;
    }

    /deep/.van-stepper__input {
      width: 45px !important;
      margin: 0 !important;
      background: #ffffff !important;
      border-left: 1px solid #e2e8f6 !important;
      border-right: 1px solid #e2e8f6 !important;
    }

    /deep/.van-stepper__plus {
      width: 32px !important;
      background: #ffffff !important;
    }

    .form-item:not(:last-child)::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 327px;
      border-bottom: 1px solid rgba(234, 236, 239, 0.5);
    }

    .form-item.color-change::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 327px;
      border-bottom: 1px solid #f6465d;
    }

    .select {
      justify-content: space-between;
      align-items: center;
    }
  }

  .asterisk {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #f6465d;
    width: 10px;
    height: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    margin-right: 4px;
  }

  .asteriskradio {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #f6465d;
    width: 10px;
    height: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 5px;
    margin-right: 4px;
  }

  .select-box {
    width: 100%;
    height: 56px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f2f4f7;

    .submit {
      width: 94px;
      height: 100%;
      line-height: 56px;
      font-size: 16px;
      font-weight: 500;
      color: #3972ff;
      text-align: center;
      font-family: PingFangSC, PingFang SC;
      font-style: normal;
    }

    .title {
      font-size: 18px;
      font-weight: 500;
      color: #1e2329;
      text-align: center;
      font-family: PingFangSC, PingFang SC;
      font-style: normal;
    }

    .close {
      width: 94px;
      height: 100%;
      line-height: 56px;
      font-size: 16px;
      font-weight: 500;
      color: #1e2329;
      text-align: center;
      font-family: PingFangSC, PingFang SC;
      font-style: normal;
    }
  }

  /deep/.overlay {
    background: rgba(30, 35, 41, 0.3);
  }

  /deep/.photo {
    height: 86px;

    .van-uploader__upload {
      height: 64px;
      width: 64px;
    }

    .van-cell__value {
      display: block;
    }

    .van-uploader__preview-image {
      width: 64px;
      height: 64px;
    }
  }
}

.purposeBox {
  width: 280px;
  display: flex;
  justify-content: space-between;

  img {
    width: 24px;
    height: 24px;
  }
}

.navBar-wrap {
  width: 100%;
  position: fixed;
  z-index: 999;
  left: 0;
  top: 0;
}

.space {
  // margin-top: 12px;
  font-size: 17px;
  color: #333333;
  height: 56px;
  border-bottom: 1px solid #ededed !important;
  // margin-bottom: 1px;
}

.spaceBlock {
  font-size: 17px;
  color: #333333;
  height: 56px;
}

.spaceMargin {
  margin-bottom: 0px;
}

/deep/.van-field__label {
  display: flex;
  align-items: center;
  width: 7em;
  margin-right: -1px;
}

/deep/.van-field {
  padding: 0;
}

/deep/.van-field__body {
  height: 100%;
}

/deep/.van-field__control {
  height: 100%;
  line-height: 100%;
  text-align: center;
  vertical-align: middle;
  font-size: 16px;
  font-weight: 500;
  color: #1e2329;
  text-align: left;
  font-family: PingFangSC, PingFang SC;
  font-style: normal;
  width: 100%;
  white-space: normal;
  word-wrap: break-word;
}

/deep/.van-cell__value--alone {
  display: block;
}

/deep/.van-field__control::placeholder {
  line-height: 24px;
  font-size: 16px;
  font-weight: 400;
  color: #b7bdc6;
  text-align: left;
  font-family: PingFangSC, PingFang SC;
  font-style: normal;
}

/deep/.van-cell__value {
  height: 100%;
  /* 根据实际高度设置 */
  line-height: 100%;
  /* 与高度相同确保垂直居中 */
  text-align: center;
  /* 文本居中 */
  vertical-align: middle;
  /* 垂直居中 */
}

/deep/.van-cell::after {
  border-bottom: 0;
}

.timeBox {
  height: 72px;
  background: #f7f7f7;
  padding: 5px 12px 0px;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;

  .time-btn {
    height: 44px;
    background: #009bff;
  }
}

.searchBox {
  height: 64px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f2f4f7;

  .searchContent {
    height: 40px;
    width: 100%;
    display: flex;
    align-items: center;
    background-color: #ffffff;
    width: 343px;
    border-radius: 20px;
  }

  .icon-wrapper {
    img {
      width: 16px;
      height: 16px;
      margin-left: 12px;
      margin-right: 8px;
    }
  }
}

/deep/.date-border {
  color: #009bff;
}

/deep/ .van-nav-bar .van-icon {
  color: #000000;
}

.cross-day-tip {
  padding: 8px 16px;
  background: #fff;
  border-bottom: 1px solid #ededed;
}

.interviewee {
  height: 100%;
  background: #f6f6f6;

  .interviewee-content {
    padding-top: 92px;
  }

  .select-navBar {
    background: #ffffff;
    line-height: 40px;
    text-align: center;
    border-bottom: 1px solid #ececec;
    font-size: 18px;
    position: relative;

    .arrow {
      height: 100%;
      padding: 3px 19px;
      position: absolute;
    }

    .title {
      font-size: 17px;
      font-weight: 500;
    }
  }

  /deep/.search {
    height: 40px;
    font-size: 14px;

    img {
      height: 16px;
      width: 16px;
    }

    .van-cell__value {
      display: block;
    }
  }

  .searchList {
    font-size: 16px;
    color: #333333;
    padding: 0px 12px;
    background: #ffffff;
    overflow: auto;

    li {
      line-height: 48px;
      padding: 0px 4px;
      border-bottom: 1px solid #ededed;
      display: flex;
      align-items: center;

      span {
        margin-left: 15px;
        color: #999999;
      }
    }
  }
}

.cropper {
  width: 48px;
  height: 48px;
  line-height: 48px;
  /* 切记position: relative一定要有 */
  position: relative;
  overflow: hidden;
  text-align: center;

  .img {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
}

/deep/.van-field__error-message {
  position: absolute;
  bottom: 0px;
  left: 0px;
  font-size: 10px;
  height: 16px;
  width: 100%;
  display: flex;
  align-items: center;
}

/deep/.timeList {
  position: relative;
  height: 500px;
  overflow: auto;

  .timeListCard {
    min-height: 56px;
    height: auto;
    border-bottom: 1px solid rgba(234, 236, 239, 0.5);
    padding: 16px 0px;
    margin-left: 20px;
    margin-right: 16px;
  }

  .intervieweeListCard {
    min-height: 56px;
    height: auto;
    border-bottom: 1px solid rgba(234, 236, 239, 0.5);
    padding: 16px 0px;
    margin-left: 20px;
    margin-right: 16px;
  }

  .purposeListCard {
    box-sizing: border-box;
    width: 351px;
    height: 56px;
    background: #ffffff;
    border-radius: 8px;
    padding-left: 24px;
    flex: 0 0 56px;
  }

  .timeListRange {
    font-size: 16px;
    font-weight: 500;
    color: #1e2329;
    line-height: 24px;
    text-align: left;
    font-family: PingFangSC, PingFang SC;
    font-style: normal;
    word-break: break-word;
    word-wrap: break-word;
  }
}

.bookBox {
  height: 72px;
  background: #f7f7f7;
  padding: 6px 12px 0px;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;

  .book-btn {
    height: 44px;
    background: #009bff;
  }
}

.timeInterval {
  padding-left: 13px;
  padding-right: 13px;
}

.time-notice {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 27px;
  height: 40px;
  width: 100%;

  img {
    height: 16px;
    width: 16px;
  }

  span {
    padding-left: 4px;
    height: 16px;
    font-size: 12px;
    color: #999999;
    line-height: 16px;
  }
}

.address {
  display: flex;
  align-items: center;

  span {
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .icon-more {
    margin-left: 5px;
    width: 16px;
    height: 16px;
  }
}

.headerBar {
  width: '100%';
  height: 47px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  border-bottom: 1px solid #ededed;
  // margin-bottom: 1px;

  .customerButton {
    width: 240px;
    height: 32px;
    background: #ffffff;
    border-radius: 24px;
    border: 1px solid #009bff;
    margin-right: 9px;
    display: flex;
    justify-content: center;
    align-items: center;

    .customerName {
      font-size: 13px;
      font-weight: 400;
      color: #009bff;
    }
  }

  .historyButton {
    width: 93px;
    height: 32px;
    background: #009bff;
    border-radius: 24px;
    display: flex;
    justify-content: center;
    align-items: center;

    .tabImg {
      width: 16px;
      height: 16px;
      margin-right: 6px;
    }

    .historyName {
      font-size: 13px;
      font-weight: 400;
      color: #ffffff;
    }
  }
}

.form-label-address {
  font-size: 16px;
  font-weight: 500;
  color: #1e2329;
  line-height: 24px;
  text-align: left;
  font-family: PingFangSC, PingFang SC;
  font-style: normal;
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  line-clamp: 3;
  box-orient: vertical;
}

.refusalInfo {
  padding-top: 300px;
  padding-bottom: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f2f4f7;
}

.refusalText {
  margin-bottom: 20px;
}

.blue-btn {
  width: 200px;
}

.outsider-info {
  height: 350px;
  overflow-y: auto;
  position: relative;
  text-align: left;
  padding: 0 10px;

  h2 {
    font-size: 22px;
    font-weight: 600;
    margin-bottom: 10px;
  }

  h3 {
    margin-bottom: 10px;
  }

  div {
    margin-bottom: 10px;
  }

  p {
    margin-bottom: 10px;
    text-indent: 2em;
  }
}

.outsider-info::-webkit-scrollbar {
  width: 0;
  background: transparent;
  display: none;
}
</style>
